import TemplateMixin from './TemplateMixin';
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';

const ALERT_BOX_IDEAL_WIDTH = 800;

@Component({})
export default class AlertBoxTemplate extends Mixins(TemplateMixin) {
  @Prop({ default: null })
  themeId: number;

  $refs: {
    widgetIframe: HTMLIFrameElement;
  };

  @Watch('alertBoxUrl')
  themeIdWatcher() {
    if (this.$refs.widgetIframe) this.$refs.widgetIframe.contentWindow.location.reload();
  }

  get alertBoxUrl(): string {
    const token = this.userSLWidgetToken || this.widgetToken;
    if (!token) return '';

    return `${process.env.MIX_STREAMLABS_URL}/widgets/studio/alert-box/v3/${token}${!this.component.useSLSettings && this.themeId ? `/${this.themeId}` : ''}`;
  }

  get alertBoxScale(): number {
    return this.component.w / ALERT_BOX_IDEAL_WIDTH;
  }
}
